{
  "search": {
    "heading": "Buscar paciente",
    "label": "Nombre, personnummer o reservnummer",
    "hint": "Mínimo {minimum} caracteres. El personnummer (número de identidad sueco) puede escribirse con o sin guion y con o sin los dígitos del siglo.",
    "searching": "Buscando …",
    "empty": "Ningún paciente de la historia clínica coincide con la búsqueda.",
    "failed": "No se pudo realizar la búsqueda.",
    "retry": "Intentar de nuevo",
    "tooLong": "El texto de búsqueda es demasiado largo. Máximo {maximum} caracteres.",
    "caption": "Resultados de la búsqueda, una fila por paciente.",
    "count": "{count, plural, =0 {Ningún resultado} one {# resultado} other {# resultados}}",
    "truncated": "Se muestran los {limit} primeros resultados. Precise la búsqueda."
  },
  "column": {
    "name": "Nombre",
    "identifier": "Personnummer / reservnr",
    "age": "Edad",
    "location": "Cama",
    "safety": "Alertas"
  },
  "location": {
    "notAdmitted": "Sin ingreso",
    "wardAndBed": "{ward} cama {bed}",
    "wardOnly": "{ward}, sin cama"
  },
  "overview": {
    "back": "Volver",
    "loading": "Cargando el resumen del paciente …",
    "failed": "No se pudo cargar el resumen del paciente.",
    "notFound": "El paciente no está en la historia clínica.",
    "retry": "Intentar de nuevo",
    "birthDate": "Fecha de nacimiento",
    "age": "Edad",
    "sex": "Sexo",
    "ward": "Unidad",
    "location": "Cama",
    "admitted": "Ingreso",
    "responsible": "Médico responsable",
    "safetyHeading": "Información de seguridad",
    "medicationsHeading": "Medicamentos actuales",
    "notesHeading": "Últimas notas",
    "noMedications": "No hay prescripciones de medicamentos actuales en la historia clínica.",
    "noNotes": "No hay notas firmadas en la historia clínica.",
    "moreNotes": "Se muestran las {count} notas más recientes. Las notas anteriores están en la historia clínica.",
    "readOnly": "Las nuevas prescripciones y la administración no forman parte de la fase 0. Se puede modificar la posología de una prescripción existente, documentar alergias y alertas, y escribir y firmar notas."
  },
  "practitioner": {
    "notDocumented": "No documentado"
  },
  "identifier": {
    "personnummer": "Personnummer",
    "samordningsnummer": "Samordningsnummer",
    "reservnummer": "Reservnummer",
    "unknownSeries": "Serie de numeración desconocida",
    "withAssigner": "{value} (emitido por {assigner})",
    "none": "Sin identificador en la historia clínica"
  },
  "sex": {
    "male": "Hombre",
    "female": "Mujer",
    "other": "Otro",
    "unknown": "Desconocido"
  },
  "safety": {
    "allergies": "Alergias",
    "dnr": "DNR",
    "treatmentLimitation": "Limitación del esfuerzo terapéutico",
    "isolation": "Aislamiento",
    "weight": "Peso",
    "infectionRisk": "Riesgo de contagio",
    "fallRisk": "Riesgo de caídas",
    "allergyStatusUnknown": "Estado alérgico no estudiado",
    "other": "Otros",
    "otherFlag": "{label}: {value}",
    "dnrNotDocumented": "Nada documentado",
    "treatmentLimitationNotDocumented": "Ninguna documentada",
    "isolationNotDocumented": "Ninguno documentado",
    "weightNotDocumented": "Ningún peso documentado",
    "weightKg": "{weight} kg",
    "valueNotRecorded": "Documentado sin más detalles",
    "isolationTypeNotRecorded": "tipo no indicado",
    "decidedBy": "Decisión: {name}, {time}",
    "decidedByWithTitle": "Decisión: {title} {name}, {time}"
  },
  "allergy": {
    "line": "{substance} ({qualifiers})",
    "lineWithReaction": "{substance} ({qualifiers}) — {reaction}",
    "substanceNotRecorded": "Sustancia no indicada",
    "severityMild": "leve",
    "severityModerate": "moderada",
    "severitySevere": "grave",
    "severityNotRecorded": "gravedad no indicada",
    "criticalityHigh": "riesgo alto ante nueva exposición",
    "criticalityLow": "riesgo bajo ante nueva exposición",
    "criticalityUnableToAssess": "riesgo no evaluable",
    "unconfirmed": "no confirmada",
    "resolved": "resuelta"
  },
  "medication": {
    "caption": "Prescripciones de medicamentos actuales, una fila por prescripción.",
    "columnSubstance": "Medicamento",
    "columnPreparation": "Preparado",
    "columnDose": "Dosis",
    "columnRoute": "Vía adm.",
    "columnSchedule": "Posología",
    "columnIndication": "Indicación",
    "columnOrdered": "Prescrito",
    "preparation": "{strength} {form}",
    "prn": "A demanda, {frequency}. Máximo {maximum} cada 24 horas.",
    "prnWithoutMaximum": "A demanda, {frequency}. No hay dosis máxima cada 24 horas documentada.",
    "orderedBy": "Prescrito por {name}",
    "endsAt": "Hasta el {time} inclusive",
    "columnCorrect": "Modificar"
  },
  "notes": {
    "typeDaily": "Nota diaria",
    "typeAdmission": "Nota de ingreso",
    "typeDischarge": "Nota de alta",
    "attribution": "{name}, {time}",
    "attributionWithTitle": "{title} {name}, {time}",
    "recordedLater": "Registrada en la historia clínica {time}",
    "amended": "Corregida, versión {version}",
    "otherLanguage": "Escrita en {language}",
    "subjective": "Subjetivo",
    "objective": "Objetivo",
    "assessment": "Valoración",
    "plan": "Plan"
  },
  "history": {
    "heading": "Versiones de los datos del paciente",
    "show": "Mostrar todas las versiones de los datos",
    "hide": "Ocultar las versiones de los datos",
    "loading": "Cargando versiones …",
    "failed": "No se pudieron cargar las versiones.",
    "notFound": "El paciente no está en la historia clínica.",
    "retry": "Intentar de nuevo",
    "count": "{count, plural, one {# versión} other {# versiones}}",
    "number": "Versión {version}",
    "current": "Versión actual",
    "superseded": "Sustituida por una versión posterior",
    "retracted": "Marcada como retirada (por error)",
    "author": "{name}",
    "authorWithTitle": "{title} {name}",
    "written": "Registrada en la historia clínica {time}",
    "effective": "Datos válidos desde {time}",
    "changed": "Modificado en esta versión",
    "fieldStatus": "Estado",
    "fieldIdentity": "Identidad",
    "identityAssumed": "Supuesta, no verificada",
    "identityEstablished": "Verificada",
    "statusActive": "Vigente",
    "statusInactive": "No vigente",
    "statusRetracted": "Retirado (por error)",
    "yes": "Sí",
    "no": "No"
  },
  "export": {
    "action": "Exportar (FHIR)",
    "working": "Exportando …",
    "refused": "Su rol no permite exportar la historia clínica.",
    "notFound": "El paciente no está en la historia clínica.",
    "unavailable": "No se pudo obtener la exportación. Intente de nuevo.",
    "notEncrypted": "El archivo no está cifrado. Esta versión solo contiene datos ficticios."
  }
}
